module.exports = "https://oms-cloud-res.99bill.com/stage2/html/website/merchant/2.0/assets/img/60cfdff69b10fb1cbbd46e08f00e4a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header-logo2.png
// module id = 632
// module chunks = 17